











































































































import Vue from "vue";
import Component from "vue-class-component";
import { Emit } from "vue-property-decorator";
import AppTextField from "#/components/AppTextField.vue";
import {
  PORTAL_OFFICE_REVIEW_IS_OPEN,
  PORTAL_OFFICE_REVIEW_APPROVAL_STATUS,
} from "@/consts/portal";

export interface PortalOfficeReviewSearchParams {
  code?: string;
  portal_office_name?: string;
  hst_no?: string;
  kst_no?: string;
  jst_no?: string;
  recruitee_name?: string;
  approval_status: number | null;
  is_open: boolean | null;
  rating_avg_gte: number | null;
  rating_avg_lt: number | null;
}

@Component({
  components: {
    AppTextField,
  },
})
export default class extends Vue {
  private code = "";
  private portal_office_name = "";
  private hst_no = "";
  private kst_no = "";
  private jst_no = "";
  private recruitee_name = "";
  private approval_status = null;
  private is_open = null;
  private rating_avg_gte = null;
  private rating_avg_lt = null;

  private PORTAL_OFFICE_REVIEW_IS_OPEN = PORTAL_OFFICE_REVIEW_IS_OPEN;
  private PORTAL_OFFICE_REVIEW_APPROVAL_STATUS =
    PORTAL_OFFICE_REVIEW_APPROVAL_STATUS;
  private ratingAvgGteItems = [
    { text: "1以上", value: 1 },
    { text: "2以上", value: 2 },
    { text: "3以上", value: 3 },
    { text: "4以上", value: 4 },
    { text: "5", value: 5 },
  ];
  private ratingAvgLtItems = [
    { text: "1より低い", value: 1 },
    { text: "2より低い", value: 2 },
    { text: "3より低い", value: 3 },
    { text: "4より低い", value: 4 },
    { text: "5より低い", value: 5 },
  ];

  @Emit()
  private search(): PortalOfficeReviewSearchParams {
    const params: PortalOfficeReviewSearchParams = {
      code: this.code,
      portal_office_name: this.portal_office_name,
      hst_no: this.hst_no,
      kst_no: this.kst_no,
      jst_no: this.jst_no,
      recruitee_name: this.recruitee_name,
      approval_status: this.approval_status,
      is_open: this.is_open,
      rating_avg_gte: this.rating_avg_gte,
      rating_avg_lt: this.rating_avg_lt,
    };
    return params;
  }
}
